import { NBSP } from 'shared/constants/symbols';

export const UTP = [
  {
    title: 'Комиссия 15%',
    description: `Мы берём её с гостя при${NBSP}бронировании, остальные 85% гость платит вам лично — при${NBSP}заселении`,
    image: 'percent',
  },
  {
    title: 'Заботливая поддержка 24/7',
    description: `Отзывчивые сотрудники быстро отвечают на${NBSP}почту и в чате круглосуточно`,
    image: 'flower',
  },
  {
    title: 'Бесплатная страховка',
    description: `Если гости что-то сломают, получите до${NBSP}300${NBSP}000${NBSP}₽ — с${NBSP}каждого случая`,
    image: 'shield',
  },
];
